var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.79 277.045C462.296 317.945 433.225 362.77 390.444 377.362C325.803 399.416 320.028 452.431 202.708 452.069C184.416 452.014 167.437 450.099 151.772 446.599C143.351 444.719 135.307 442.369 127.652 439.598C58.153 414.528 20.101 354.907 14.671 291.197C7.51605 207.403 64.54 165.128 101.7 140.229C138.86 115.33 181.231 22.777 296.567 22.227C314.152 22.151 331.766 23.874 348.922 27.82C388.085 36.811 428.38 58.49 452.586 91.522C454.403 94.004 456.143 96.548 457.816 99.144C490.464 149.943 494.191 221.286 475.79 277.045Z",
    fill: "#3AF2AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M475.79 277.045C462.296 317.945 433.225 362.77 390.444 377.362C325.803 399.416 320.028 452.431 202.708 452.069C184.416 452.014 167.437 450.099 151.772 446.599C143.351 444.719 135.307 442.369 127.652 439.598C58.153 414.528 20.101 354.907 14.671 291.197C7.51605 207.403 64.54 165.128 101.7 140.229C138.86 115.33 181.231 22.777 296.567 22.227C314.152 22.151 331.766 23.874 348.922 27.82C388.085 36.811 428.38 58.49 452.586 91.522C454.403 94.004 456.143 96.548 457.816 99.144C490.464 149.943 494.191 221.286 475.79 277.045Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2899 65.842H41.5959V79.536H55.2899V65.842Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.767 72.689H121.019",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2899 85.0129H41.5959V98.7069H55.2899V85.0129Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.767 91.8599H121.019",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2899 104.184H41.5959V117.878H55.2899V104.184Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.767 111.031H121.019",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2899 123.355H41.5959V137.049H55.2899V123.355Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.767 130.202H121.019",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2899 142.526H41.5959V156.22H55.2899V142.526Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.767 149.373H121.019",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2899 161.697H41.5959V175.39H55.2899V161.697Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.767 168.544H121.019",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M438.917 307.461H429.497V316.881H438.917V307.461Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M442.684 312.171H484.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M438.917 320.649H429.497V330.069H438.917V320.649Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M442.684 325.359H484.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M438.917 333.836H429.497V343.256H438.917V333.836Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M442.684 338.546H484.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M438.917 347.024H429.497V356.444H438.917V347.024Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M442.684 351.734H484.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M438.917 360.212H429.497V369.632H438.917V360.212Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M442.684 364.922H484.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M438.917 373.4H429.497V382.82H438.917V373.4Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M442.684 378.109H484.131",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M267.229 64.5239H207.928V106.974H267.229V64.5239Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M207.928 64.5239L237.578 85.7489L267.229 64.5239",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M308.321 51.511H271.981V77.524H308.321V51.511Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M271.981 51.511L290.15 64.518L308.32 51.511",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.043 400.735H40.703V426.748H77.043V400.735Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.703 400.735L58.873 413.741L77.042 400.735",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19.347 459.449H483.589",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M419.682 128.64H93.325V441.36H419.682V128.64Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M425.097 124.428H98.74V437.148H425.097V124.428Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M259.063 139.525V420.546",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M232.671 229H125.984V247.093H232.671V229Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M232.671 262.69H125.984V280.783H232.671V262.69Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M225.474 328H133.525C129.369 328 126 325.777 126 323.035V310.966C126 308.223 129.369 306 133.525 306H225.474C229.631 306 233 308.223 233 310.966V323.035C233 325.777 229.631 328 225.474 328Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.904 183.103H276.626V192.775H297.904V183.103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.804 171.078H288.526V180.75H309.804V171.078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.756 183.103H301.478V192.775H322.756V183.103Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.797 149.816H338.519V159.488H359.797V149.816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.697 137.791H350.419V147.463H371.697V137.791Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.649 149.816H363.371V159.488H384.649V149.816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.756 213.967H301.478V223.639H322.756V213.967Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.656 201.942H313.378V211.614H334.656V201.942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.608 213.967H326.33V223.639H347.608V213.967Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.295 304.958H368.017V314.63H389.295V304.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.195 292.933H379.917V302.605H401.195V292.933Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.147 304.958H392.869V314.63H414.147V304.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.295 405.167H368.017V414.839H389.295V405.167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.195 393.142H379.917V402.814H401.195V393.142Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.147 405.167H392.869V414.839H414.147V405.167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.516 327.004H282.238V336.676H303.516V327.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.416 314.979H294.138V324.651H315.416V314.979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.368 327.004H307.09V336.676H328.368V327.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.516 361.877H282.238V371.549H303.516V361.877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.416 349.852H294.138V359.524H315.416V349.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.368 361.877H307.09V371.549H328.368V361.877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.621 361.877H332.343V371.549H353.621V361.877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.521 349.852H344.243V359.524H365.521V349.852Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.473 361.877H357.195V371.549H378.473V361.877Z",
    fill: "black"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M325.678 287.012C325.678 287.012 322.393 304.952 321.888 310.258C321.383 315.564 320.877 337.168 324.667 351.823C328.457 366.478 334.016 377.343 334.016 377.343C334.016 377.343 336.543 387.703 338.059 390.482C339.575 393.261 352.209 414.739 352.209 414.739C352.209 414.739 351.451 423.583 350.946 425.099C350.441 426.615 348.672 435.964 349.177 438.743C349.682 441.522 350.44 443.291 349.682 446.829C348.924 450.366 347.913 453.904 349.682 456.936C351.451 459.968 355.746 460.221 357.009 458.452C358.272 456.683 360.547 453.146 359.789 448.092C359.031 443.039 356.504 436.469 357.009 433.69C357.514 430.911 359.283 427.373 359.283 427.373C359.283 427.373 368.885 447.082 369.39 448.598C369.895 450.114 370.906 456.431 371.411 458.452C371.916 460.473 374.696 457.694 375.706 456.431C376.717 455.168 380.507 449.861 379.749 446.324C378.991 442.786 376.717 436.47 376.717 436.47L380.493 441.448C380.863 441.936 381.635 441.551 381.465 440.962C380.759 438.527 379.803 435.314 379.496 434.701C378.991 433.69 378.738 430.406 376.717 427.626C374.696 424.846 369.137 427.373 369.137 427.373L364.842 413.729C364.842 413.729 372.675 387.956 371.159 379.365C369.643 370.774 368.885 364.457 369.39 362.688C369.895 360.919 379.497 334.262 379.497 328.703C379.497 323.144 379.75 309.752 376.718 302.425C373.686 295.098 369.643 288.275 369.643 288.275L325.678 287.012Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M368.225 424.473L364.842 413.729C364.842 413.729 372.675 387.956 371.159 379.365C369.643 370.774 368.885 364.457 369.39 362.688C369.895 360.919 378.609 334.191 379.497 328.703C381.163 318.407 379.75 309.752 376.718 302.425C373.686 295.098 369.643 288.275 369.643 288.275L325.678 287.012C325.678 287.012 322.393 304.952 321.888 310.258C321.383 315.564 320.877 337.168 324.667 351.823C328.457 366.478 334.016 377.343 334.016 377.343C334.016 377.343 336.543 387.703 338.059 390.482C339.575 393.261 352.209 414.739 352.209 414.739C352.209 414.739 351.773 419.818 351.342 422.937C352.934 423.999 355.173 425.212 357.262 425.351L359.283 427.372C359.283 427.372 365.026 429.901 368.225 424.473Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M361.7 403.142C360.487 398.476 358.965 392.711 358.02 389.471C356.251 383.407 350.692 367.994 350.692 367.994L346.144 321.881L337.553 316.322",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M363.579 410.444C363.579 410.444 363.203 408.964 362.632 406.748",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M354.97 310.964C352.535 314.789 349.811 319.474 348.672 322.892",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M359.537 304.194C359.537 304.194 358.512 305.611 357.076 307.748",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M379.498 434.7C378.993 433.689 378.74 430.404 376.719 427.625C376.115 426.794 375.192 426.443 374.198 426.352C375.925 430.695 374.324 434.184 375.203 437.48C376.214 441.27 376.972 444.555 375.456 447.334C373.94 450.113 370.15 451.629 370.15 451.629L370.08 451.642C370.554 454.076 371.088 457.15 371.413 458.451C371.918 460.472 374.698 457.693 375.708 456.43C376.719 455.167 380.509 449.86 379.751 446.323C378.993 442.785 376.719 436.469 376.719 436.469L381.103 442.248C381.348 442.57 381.858 442.319 381.746 441.93C381.042 439.477 379.847 435.399 379.498 434.7Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M359.853 448.642C359.482 449.842 359.004 451.324 358.526 452.64C357.515 455.419 354.23 455.672 351.956 453.145C349.682 450.618 349.682 446.828 349.682 446.828C348.924 450.365 347.913 453.903 349.682 456.935C351.451 459.967 355.746 460.22 357.009 458.451C358.227 456.748 360.372 453.4 359.853 448.642Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M321.909 224.867C321.909 224.867 318.066 226.214 318.232 226.71C318.398 227.207 312.103 258.681 312.103 258.681C312.103 258.681 307.63 270.277 308.127 274.418C308.624 278.559 312.103 283.529 316.078 283.529C320.053 283.529 321.545 281.044 322.373 279.885C323.201 278.725 326.017 273.259 326.017 273.259C326.017 273.259 325.023 283.695 324.692 284.689C324.361 285.683 322.704 288.333 323.532 289.162C324.36 289.99 326.679 291.316 327.839 291.647C328.999 291.978 341.92 294.463 353.184 293.801C364.448 293.139 371.24 290.157 371.24 290.157C371.24 290.157 372.234 287.01 372.565 286.513C372.896 286.016 373.559 285.188 373.559 285.188C373.559 285.188 384.161 284.028 384.823 283.366C385.486 282.703 387.308 279.887 387.142 275.415C386.976 270.942 388.633 232.179 387.805 231.351C386.977 230.523 383.097 228.551 383.097 228.551L363.908 217.827L335.292 221.578L321.909 224.867Z",
    fill: "#40B0D5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M322.107 233.115C322.107 233.115 325.576 239.475 326.443 243.522",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M314.687 261.156C314.687 261.156 319.216 261.734 320.95 264.143",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M319.602 260.867C319.602 260.867 321.818 262.023 322.3 263.083",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M310.28 267.13C310.28 267.13 312.102 263.486 314.918 262.989C317.734 262.492 321.71 265.143 321.71 265.143L324.029 264.315L327.011 270.444L326.017 273.26",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M380.221 235.147C380.221 235.147 377.73 240.784 376.944 242.619",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M373.56 285.187L363.921 276.083",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M369.784 283.843L360.126 278.842",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M332.533 292.121L358.057 289.362",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M353.745 231.76C353.745 231.76 350.813 260.561 350.641 262.113",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M349.089 273.323L348.227 282.809",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M365.703 213.042L363.162 219.469L354.792 229.035L347.318 219.17L347.933 206.714L357.333 215.284L365.703 213.042Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M358.089 173.58C358.089 173.58 343.363 178.912 341.332 183.101C339.301 187.29 337.397 194.907 337.397 195.415C337.397 195.923 330.415 198.716 329.018 200.874C327.622 203.032 329.145 209.38 329.018 211.157C328.891 212.934 322.417 214.966 321.782 218.901C321.147 222.836 321.909 224.868 321.909 224.868L333.207 223.091C333.207 223.091 340.57 226.011 344.506 224.487C348.441 222.964 348.822 215.347 348.568 212.808C348.314 210.269 347.933 206.714 347.933 206.714L353.138 191.988L364.944 188.433L372.434 195.415L365.553 213.49C365.553 213.49 363.379 217.878 363.759 219.02C364.14 220.163 367.609 221.312 367.609 221.312L383.097 228.548C383.097 228.548 383.732 226.898 383.478 224.866C383.224 222.835 379.923 218.519 379.923 217.249C379.923 215.979 384.239 211.028 382.208 206.585C380.177 202.142 378.019 199.73 376.876 197.445C375.734 195.16 377.892 190.844 375.606 185.258C373.32 179.672 365.831 174.848 363.8 173.706C361.771 172.564 358.089 173.58 358.089 173.58Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M363.421 183.863C363.421 183.863 351.996 188.941 351.107 191.353C350.218 193.765 347.806 204.936 347.933 206.714C348.06 208.491 355.677 217.632 357.2 217.886C358.723 218.14 366.548 213.61 367.945 212.594C369.342 211.578 373.958 196.304 373.831 193.892C373.704 191.48 364.691 183.99 363.421 183.863Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M350.99 193.33C358.773 191.255 363.421 183.863 363.421 183.863C363.421 183.863 369.15 194.109 374.338 195.665",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M363.421 183.863C363.421 183.863 352.027 193.33 348.136 194.109",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M363.675 206.587C363.675 206.587 361.898 207.983 360.12 207.476",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M355.804 208.364C355.804 208.364 358.47 211.792 363.04 209.76",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M360.12 196.177C360.12 196.177 356.946 194.019 353.9 195.415",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M365.96 196.938C365.96 196.938 369.515 195.542 371.165 197.192",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M357.829 199.974C357.746 200.741 357.199 201.311 356.607 201.247C356.015 201.183 355.601 200.51 355.684 199.743C355.767 198.976 356.314 198.406 356.906 198.47C357.498 198.534 357.912 199.207 357.829 199.974Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M367.858 201.497C367.775 202.264 367.228 202.834 366.636 202.77C366.044 202.706 365.63 202.033 365.713 201.266C365.796 200.499 366.343 199.929 366.935 199.993C367.527 200.057 367.941 200.73 367.858 201.497Z",
    fill: "#263238"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M343.133 224.7L347.617 232.622L353.297 226.942L347.318 219.17L343.133 224.7Z",
    fill: "#40B0D5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M356.884 227.241L360.92 233.071L367.61 221.313L363.91 217.825L356.884 227.241Z",
    fill: "#40B0D5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M337.968 266.745H329.18L328.081 246.413H339.067L337.968 266.745Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M340.03 244.678H326.925V247.761H340.03V244.678Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M338.392 243.233H328.756V244.679H338.392V243.233Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M327.657 268.566C327.643 268.624 327.632 268.666 327.625 268.687C327.075 270.248 325.703 271.301 324.048 271.438C323.182 271.51 322.27 271.259 321.642 270.658C321.008 270.051 320.721 269.159 320.631 268.286C320.411 266.158 320.749 265.29 322.051 263.746C322.468 263.251 324.084 261.965 324.166 261.323L325.06 254.301C325.06 254.301 333.777 252.311 334.536 252.406C335.294 252.501 335.484 253.259 335.294 253.827C335.105 254.395 333.778 254.68 333.494 254.774C333.21 254.869 328.946 255.911 328.946 255.911L327.43 257.711C327.43 257.711 329.42 256.763 329.704 256.763C329.988 256.763 334.726 256.1 335.295 256.005C335.864 255.91 336.622 256.668 336.243 257.426C335.864 258.184 335.58 258.374 335.295 258.374C335.01 258.374 330.273 259.227 330.273 259.227L327.62 261.501C327.62 261.501 331.221 260.364 331.6 260.364C331.979 260.364 335.295 260.269 335.39 260.838C335.485 261.407 335.295 262.07 334.632 262.259C333.969 262.449 331.41 262.828 331.41 262.828L328.567 264.344H331.315C331.315 264.344 333.968 265.197 334.537 265.292C335.106 265.387 335.485 265.671 334.727 266.524C333.969 267.376 328.076 266.694 328.069 266.694C328.033 266.69 327.764 268.112 327.657 268.566Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M373.622 264.494L371.737 266.968C371.737 266.968 371.737 281.927 372.326 283.223C372.915 284.519 377.509 287.935 379.982 287.935C382.455 287.935 387.285 282.281 387.521 281.339C387.756 280.397 381.396 262.139 381.514 261.668C381.632 261.197 380.925 260.608 380.1 260.608C379.276 260.607 373.622 264.494 373.622 264.494Z",
    fill: "#40B0D5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M380.149 255.557L380.454 261.902C380.454 261.902 380.101 264.493 378.451 265.553C376.802 266.613 374.564 266.613 374.564 266.613L373.504 264.493L371.855 262.844L380.149 255.557Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M382.056 246.944L370.128 244.454L362.656 264.378L372.749 266.213L382.056 246.944Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M380.416 252.005C380.416 252.005 372.423 252.36 372.335 252.982C372.246 253.604 372.513 254.403 372.779 254.492C373.045 254.581 380.15 255.558 380.15 255.558C380.15 255.558 382.104 255.114 382.015 253.515C381.926 251.916 380.416 252.005 380.416 252.005Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M375.887 255.113C375.887 255.113 368.871 254.314 368.516 254.758C368.161 255.202 367.806 255.824 368.871 256.268C369.937 256.712 376.331 258.488 376.864 258.488C377.397 258.488 378.907 258.044 379.351 257.156C379.795 256.268 379.529 255.735 379.529 255.735L375.887 255.113Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M372.246 257.422C372.246 257.422 366.917 256.356 366.651 256.889C366.385 257.422 366.296 258.31 366.829 258.665C367.362 259.02 374.467 260.974 374.911 261.152C375.355 261.33 376.421 260.797 376.776 260.086C377.131 259.376 376.865 258.488 376.865 258.488L372.246 257.422Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M372.423 260.53C372.423 260.53 368.427 259.731 368.249 260.175C368.071 260.619 367.982 261.596 368.782 261.862C369.581 262.128 374.199 263.993 374.998 263.46C375.797 262.927 375.531 261.506 375.531 261.506L372.423 260.53Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step-1.40bd9bfe6aa7149f34b2a2c773a21cf0.svg";
export { ForwardRef as ReactComponent };